/**
 * A draft artifact, whole. The person reads it here and sends it themselves.
 * The body is markdown from a skill; this screen formats it.
 */
import { fmtDate, fmtTime, plural } from "@trellis/core";
import { renderMarkdown } from "../markdown.js";

export interface DraftView {
  id: string;
  artifactId: string;
  title: string;
  version: number;
  status: string;
  createdAt: string;
  body: string;
  citations: unknown[];
  canApprove?: boolean;
  /** The contract's name, for the breadcrumb: the route carries only its id. */
  programName?: string;
}

export function DraftScreen({ draft, programId, notice, onDownload, onApprove }: {
  draft: DraftView;
  programId: string;
  notice?: string | undefined;
  onDownload: () => void;
  onApprove?: (() => void) | undefined;
}) {
  const titleLine = new RegExp(`^#\\s+${draft.title.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\s*\\n+`);
  const html = renderMarkdown(draft.body.replace(titleLine, ""));
  return (
    <div class="body draft-page">
      <main class="main program">
        <div class="contract-head">
          <p class="note dim"><a class="link" href={`/app/programs/${encodeURIComponent(programId)}`}>{draft.programName ?? programId}</a></p>
          <div class="contract-title">
            <h1 class="h-lg">{draft.title}</h1>
            <p class="note dim code">{draft.artifactId} · v{draft.version} · {draft.status}</p>
          </div>
          <p class="lede">
            Written from confirmed commitments and the contract record. Nothing is sent until you send it.
          </p>
          <p class="note dim">Drafted {fmtDate(draft.createdAt)} {fmtTime(draft.createdAt)} · {plural(draft.citations.length, "citation")}</p>
        </div>
        {notice && <div class="notice">{notice}</div>}
        <div class="buttons">
          {draft.canApprove && draft.status !== "approved" && onApprove && <button class="btn" onClick={onApprove}>Approve</button>}
          <button class="btn quiet" onClick={onDownload}>Download</button>
        </div>
        <article class="draft-body md" dangerouslySetInnerHTML={{ __html: html }} />
      </main>
    </div>
  );
}
